import { Roles } from '@/auth/azure/Roles'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'
import AnalysisEditor from '@/routes/analysis/AnalysisEditor'
import { analysisEditorRouteAction, analysisEditorRouteLoader } from '@/routes/analysis/AnalysisEditor.route'
import { RoleRouteObject } from '@/types'

const AnalysisCreatorRoute = {
  path: 'new',
  element: <AnalysisEditor creating={true} />,
  loader: analysisEditorRouteLoader,
  action: analysisEditorRouteAction,
  allowedRoles: [Roles.Guest],
  handle: {
    crumb: () => createDescriptor,
  },
} as RoleRouteObject

export default AnalysisCreatorRoute
